module.exports = __webpack_public_path__ + "img/PENZ.1cec9ba8.png";